

module.exports = __webpack_require__.stylable.create(
    "GroupList2461029283",
    {"classes":{"root":"GroupList2461029283__root","emptyRoot":"GroupList2461029283__emptyRoot","emptyStateHeader":"GroupList2461029283__emptyStateHeader","emptyStateText":"GroupList2461029283__emptyStateText","grid":"GroupList2461029283__grid"},"vars":{"groupCardBorderColor":"--GroupList2461029283-groupCardBorderColor","groupCardBorderWidth":"--GroupList2461029283-groupCardBorderWidth"},"stVars":{},"keyframes":{}},
    "",
    1,
    "GroupList2461029283",
    null
);
